import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
// import PaginationOld from '../pages/PaginationOld';
import { db } from '../../firebase'





function AllDoctor() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(2500);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [labtest, setLabtest] = useState([])
    const navigate = useNavigate()

    const labtestCollectionRef = collection(db, "All Doctor");
    useEffect(() => {

        const getLabtest = async () => {
            const data = await getDocs(labtestCollectionRef);
            setLabtest(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getLabtest()
    }, [])
    return (

        <>
     


<div className='topdoctor'>
            <div className="album py-2">

                <div className="container">
                    
                              <h1 className='mt-1'><b>Find <b style={{color:"#CC000A"}}>Doctor</b></b></h1>
                           
                           
                    <h4 className='mt-2'><b>We are proud to be associated with some of  the <br/> <b style={{color:"#CC000A"}}>best doctors</b> in the field.</b></h4>

                    <div className="row">

                        <div className="col-md-6">

                            <div className="card-body">
                                <input type="text" className="form-control" placeholder="Search" name="location"
                                    onChange={(e) => {
                                        setsearchTerm(e.target.value);
                                    }}
                                />
                                <div className="d-flex justify-content-between align-items-center">




                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>


            <div className="album py-4">

                <div className="container">

                    <div className="row">
                        {labtest.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.name.toLowerCase().includes(searchTerm.toLowerCase())


                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((elitemedicalcare) => {
                            return (
                                <div className="col-md-4 mt-8" >
                                    <div className="card cardnew mb-2">
                                        <img className="card-img-top" src={elitemedicalcare.img} alt={elitemedicalcare.name} />
                                        <div className="card-body">

                                            <h3 style={{ color: "#0B0E5E" }} className="card-text mb-0"> <b>{elitemedicalcare.name}</b></h3>

                                            <p style={{ color: "grey" }} className="card-text mb-1"><small>{elitemedicalcare.des}</small></p>
                                            <p style={{ color: "grey" }} className="card-text mb-2"><small>{elitemedicalcare.degree}</small></p>
                                            <h6 className="card-text" style={{ color: "#0637A1" }}>Reg. {elitemedicalcare.reg} </h6>
                                            <h5 style={{ color: "grey" }} className="card-text mb-2"><small>{elitemedicalcare.des2}</small></h5>
                                            <h4 className="blink" style={{ color: "maroon" }}>{elitemedicalcare.date} </h4>


                                            {/* <h5 style={{ color: "#960961" }} className="card-text mb-3">  {elitemedicalcare.fees}</h5> */}

                                            <div className="d-flex justify-content-between align-items-center">
                                                <a href='tel: +91 9732775201' className='orthopedicDrSuvenduPramanik  me-2 mb-2'><b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-plus-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5"/>
</svg> Book Appointment</b></a>
                                            </div>

                                            {/* <div className="d-flex justify-content-start align-items-center mb-2">
                                                <a className='btn-grad20' href={elitemedicalcare.link} target='_black' rel="noopener noreferrer" ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-youtube" viewBox="0 0 16 16">
                                                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                                                </svg> {elitemedicalcare.text}</a>
                                            </div> */}


                                        </div>

                                    </div>

                                </div>

                            )
                        })}
                    </div>

                </div>
                </div>
            </div>

        </>

    );
}

export default AllDoctor;



